import { PatientsWithTotalCount, type PatientResponseDto } from 'types/types';
import { request as __request } from '../request/request';
import { OpenAPI } from '../request/open-api';

export const getPatients = () => {
  return __request<PatientResponseDto[]>(OpenAPI, {
    method: 'GET',
    url: '/patients/paginated/',
    errors: {
      400: `Bad Request`,
      401: `Unauthorized`,
      403: `Forbidden`,
      404: `Not Found`,
      422: `Unprocessable Entity`,
    },
  });
};

export const getPatientById = (patientId: string) => {
  return __request<PatientResponseDto>(OpenAPI, {
    method: 'GET',
    url: `/patients/${patientId}`,
    errors: {
      400: `Bad Request`,
      401: `Unauthorized`,
      403: `Forbidden`,
      404: `Not Found`,
      422: `Unprocessable Entity`,
    },
  });
};

export const getCaregiverPatients = (caregiverId: string, skip = 0, limit = 100, haveTotalCount = true) => {
  return __request<PatientsWithTotalCount>(OpenAPI, {
    method: 'GET',
    url: `/patients/caregiverId/${caregiverId}`,
    query: {
      limit,
      skip,
      have_total_count: haveTotalCount.toString(),
    },
    errors: {
      400: `Bad Request`,
      401: `Unauthorized`,
      403: `Forbidden`,
      404: `Not Found`,
      422: `Unprocessable Entity`,
    },
  });
};

export const getPatientsByFacility = (facilityId: string, skip = 0, limit = 999) => {
  return __request<PatientsWithTotalCount>(OpenAPI, {
    method: 'GET',
    url: `/patients/facility/${facilityId}`,
    query: {
      skip,
      limit,
    },
    errors: {
      400: `Bad Request`,
      401: `Unauthorized`,
      403: `Forbidden`,
      404: `Not Found`,
      422: `Unprocessable Entity`,
    },
  });
};
